import { httpClient } from './core';
import { grundHeader } from '../../components/ui/loeschen-mit-grund-dialog';

export interface MarketingCouponCodeDto {
  id: number;
  code: string;
  valueCents: number;
  singleUse: boolean;
  isActive: boolean;
  validFrom: string | null;
  validUntil: string | null;
  createdByUserId: number | null;
  allowedWpUserIds: number[];
  scopeCount: number;
  redemptionCount: number;
  createdAt: string | null;
  updatedAt: string | null;
}

export interface SaveMarketingCouponPayload {
  code: string;
  valueEuro?: number;
  singleUse: boolean;
  isActive: boolean;
  validFrom?: string | null;
  validUntil?: string | null;
  allowedWpUserIds: number[];
}

export const marketingCouponsApi = {
  list: async (): Promise<MarketingCouponCodeDto[]> => {
    const res = await httpClient<MarketingCouponCodeDto[]>('/api/marketing/coupon-codes');
    if (res.error) throw new Error(res.error);
    return res.data || [];
  },

  create: async (payload: SaveMarketingCouponPayload): Promise<MarketingCouponCodeDto> => {
    const res = await httpClient<MarketingCouponCodeDto>('/api/marketing/coupon-codes', {
      method: 'POST',
      body: JSON.stringify(payload),
    } as RequestInit);
    if (res.error || !res.data) throw new Error(res.error || 'Gutscheincode konnte nicht erstellt werden');
    return res.data;
  },

  update: async (id: number, payload: Partial<SaveMarketingCouponPayload>): Promise<MarketingCouponCodeDto> => {
    const res = await httpClient<MarketingCouponCodeDto>(`/api/marketing/coupon-codes/${id}`, {
      method: 'PUT',
      body: JSON.stringify(payload),
    } as RequestInit);
    if (res.error || !res.data) throw new Error(res.error || 'Gutscheincode konnte nicht aktualisiert werden');
    return res.data;
  },

  remove: async (id: number, grund: string): Promise<void> => {
    const res = await httpClient<{ ok: boolean }>(`/api/marketing/coupon-codes/${id}`, { method: 'DELETE', ...grundHeader(grund) } as RequestInit);
    if (res.error) throw new Error(res.error);
  },
};
